var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"online-dashboard-wrapper"},[_c('Navbar'),(_vm.showBonusLine && _vm.$device.mobile)?_c('EndYearBonus'):_vm._e(),_c('left-side-menu'),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }